import { gql } from '@apollo/client';

const TaxProfileReviewInfo = gql`
  fragment TaxProfileReviewInfo on TaxProfileReview {
    id
    changedFields
    createdAt
    failureCode
    productId
    resolvedAt
    resolvedById
    sourceTaxProfileId
    state
    taxProfileId
    trigger
    updatedAt
  }
`;

export default TaxProfileReviewInfo;
